import React from "react";
import { useNavigate } from "react-router-dom";
import "./Login.scss";
import loginImage from "../../assets/images/login-image.png";
import logo from "../../assets/images/logo.svg";
import leftIcon from "../../assets/images/chevron-left.svg";
import { Button } from 'primereact/button';
import { commonPostApi } from "../../utils/apiService";
import { useForm } from "react-hook-form";
import InputPrimaryComponents from '../../components/common/inputPrimaryComponents';
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";


const ResetPassword = () => {
  const tokenParam = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm();

  const handlePasswordReset = (formData) => {
    if (formData.password !== formData.confirmPassword) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.VALIDATION.REQUIRED_FIELDS);
      return;
    }

    commonPostApi("/reset-password", {
      password: formData.password,
      confirm_password: formData.confirmPassword,
      token: tokenParam?.get?.("token")
    }).then((response) => {
      if (response?.status === 200) {
        showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.AUTH.PASSWORD_CHANGED);
        navigate("/login");
      } else if (response?.response?.data) {
        const errorMessage = typeof response.response.data === 'object' && response.response.data.message
          ? response.response.data.message
          : typeof response.response.data === 'string'
            ? response.response.data
            : COMMON_MSG.ERROR.GENERIC;
        showToast(TOAST_TYPE.ERROR, errorMessage);
      } else {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
      }
    }).catch((error) => {
      console.error("Reset password error:", error);
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
    });
  };
  
  return (
    <div className="Login__main-container">
        <div className="Login__image-sec">
          <img src={loginImage} alt="Login Background" />
        </div>
      <div className="Login__right-section">
        <div className="Login__right-log-sec">
          <img src={logo} alt="Company Logo" />
        </div>
        <div className="Login__right-form-sec">
          <div className="Login__reset-pwd-sec">
            <div className="Login__right-header-sec">
              <p className="heading">Reset Password</p>
              <p className="sub-heading">Your new password must be different from previously used passwords</p>
            </div>
            <form onSubmit={handleSubmit(handlePasswordReset)}>
              <div className="Login__form-container mt-4">
                <div className="Login__form-control">
                  <InputPrimaryComponents
                    type="password"
                    label="New Password"
                    errors={errors}
                    control={control}
                    name="password"
                    rules={{ required: "New password is required" }}
                    paddingStyle={true}
                    autoFocus={true}
                  />
                </div>
                <div className="Login__form-control">
                  <InputPrimaryComponents
                    type="password"
                    label="Confirm Password"
                    errors={errors}
                    control={control}
                    name="confirmPassword"
                    rules={{ required: "Confirm password is required" }}
                    paddingStyle={true}
                  />
                </div>
                <div className="Login__login-btn">
                  <Button type="submit" label="Set New Password" />
                </div>
                <div className="Login__contact-admin-sec back-to-login">
                  <span className="btn-left-icon"><img src={leftIcon} alt="Back Icon" /></span>
                  <Button link label="Back to Login" onClick={()=>navigate("/")}/>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
